import { useDispatch } from 'react-redux';
import { fetchFavoriteAction } from '../store/reducer/favoriteSlice';

export const useFavorite = () => {
  const dispatch = useDispatch();
  const fetchFavorites = async () => {
    await dispatch(fetchFavoriteAction({ page: 1, perPage: 10 }));
  };

  return { fetchFavorites };
};
